// Duty holder type
export interface DutyHolderType {
    id: number;
    dutyholder_type: "Client" | "Principal Designer" | "Principal Contractor" | "Principal Engineer";
    status: 1 | 0;
    is_client: 1 | 0;
    is_added: boolean;
}

export const mapDutyHolderType = (data: any): DutyHolderType => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const dutyHolderType: DutyHolderType = {
        id: data?.id,
        dutyholder_type: data?.dutyholder_type,
        status: data?.status,
        is_client: data?.is_client,
        is_added: data?.is_added
    };

    return dutyHolderType;
};

export const mapDutyHolderTypes = (data: any[]): DutyHolderType[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapDutyHolderType);
};

// Duty holder data
export interface DutyHolderData {
    id: number;
    project_id: number;
    folder_id: number;
    dutyholder_type_id: number;
    client_name: string | null;
    address: string | null;
    email: string | null;
    telephone: string | null;
    work_complete_date: string | null;
    declare_that: string | null;
    principal_designer: string | null;
    name: string | null;
    appointment_date: string | null;
    sign_report: 1 | 0;
    sign: string | null;
    sign_date: string | null;
    personal_info_id: number | null;
    sub_contact_id: number | null;
    this_user_part: boolean;
    dutyholder_type: DutyHolderType | null;
}

export const mapDutyHolderData = (data: any): DutyHolderData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const dutyHolderData: DutyHolderData = {
        id: data?.id,
        project_id: data?.project_id,
        folder_id: data?.folder_id,
        dutyholder_type_id: data?.dutyholder_type_id,
        client_name: data?.client_name ?? null,
        address: data?.address ?? null,
        email: data?.email ?? null,
        telephone: data?.telephone ?? null,
        work_complete_date: data?.work_complete_date ?? null,
        declare_that: data?.declare_that ?? null,
        principal_designer: data?.principal_designer ?? null,
        name: data?.name ?? null,
        appointment_date: data?.appointment_date ?? null,
        sign_report: data?.sign_report,
        sign: data?.sign ?? null,
        sign_date: data?.sign_date ?? null,
        personal_info_id: data?.personal_info_id ?? null,
        sub_contact_id: data?.sub_contact_id ?? null,
        this_user_part: data?.this_user_part ?? false,
        dutyholder_type: data?.dutyholder_type ? mapDutyHolderType(data?.dutyholder_type) : null
    };

    return dutyHolderData;
};

export const mapDutyHolderDatas = (data: any[]): DutyHolderData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapDutyHolderData);
};